document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-menu-toggle]');
  if (toggle) {
    const menu = document.querySelector('[data-mobile-menu]');
    const open = menu.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', open);
  }
  const searchToggle = event.target.closest('[data-search-toggle]');
  if (searchToggle) {
    const panel = document.querySelector('[data-search-panel]');
    panel.hidden = !panel.hidden;
    if (!panel.hidden) panel.querySelector('input').focus();
  }

  const submenuToggle = event.target.closest('[data-submenu-toggle]');
  if (submenuToggle) {
    const item = submenuToggle.closest('.nav-item');
    const willOpen = !item.classList.contains('is-open');
    document.querySelectorAll('.nav-item.is-open').forEach((openItem) => {
      openItem.classList.remove('is-open');
      openItem.querySelector('[data-submenu-toggle]')?.setAttribute('aria-expanded', 'false');
    });
    item.classList.toggle('is-open', willOpen);
    submenuToggle.setAttribute('aria-expanded', String(willOpen));
    event.stopPropagation();
  } else if (!event.target.closest('.nav-item')) {
    document.querySelectorAll('.nav-item.is-open').forEach((item) => {
      item.classList.remove('is-open');
      item.querySelector('[data-submenu-toggle]')?.setAttribute('aria-expanded', 'false');
    });
  }
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    document.querySelectorAll('.nav-item.is-open').forEach((item) => {
      item.classList.remove('is-open');
      item.querySelector('[data-submenu-toggle]')?.setAttribute('aria-expanded', 'false');
    });
  }
});

document.addEventListener('shopify:section:load', () => window.scrollTo(0, window.scrollY));
